module.exports = __webpack_public_path__ + "static/media/buildDocument.9de11b92.gif";